<template lang="pug">
.container-auth
    //- img.logo-global(alt="Vue logo" src="./../../assets/logo-vw.svg")
    img.logo-global(alt="Vue logo" :src="logo")
    .box
        .box__header
            h2.heading.pl-2 Reset Password
        .box__body.p-6
            form(action="" method="method")
                p.text-gray-600.mb-6
                    | Please Reset your password and login back.
                .field.mb-4
                    label.block.text-sm.font-bold.mb-2(for="field") New Password
                    input.field-style(id="field" type="text" placeholder="New Password")

                .field.mb-4
                    label.block.text-sm.font-bold.mb-2(for="field") Confrim New Password
                    input.field-style(id="field" type="text" placeholder="Confrim New Password")

                .flex.items-center.justify-between
                        button.btn-primary.btn-large(type='submit')
                            Strong RESET
    span.text-gray-500.text-xs.text-center.block © {{ app_name }} 2020
        
</template>

<script>
export default {
    name: 'PageResetPassword',
    data(){
        return {
            // app_name: process.env.VUE_APP_APP_NAME,
            // logo: process.env.VUE_APP_APP_LOGO,
            app_name: this.$store.getters.getTitleGlobal,
            logo: this.$store.getters.getLogo,
        };
    },
}
</script>

<style lang="sass" scoped>
.container-auth
    max-width: 420px
    margin: 32px auto

    .logo-global
        max-width: 150px
        margin: 0 auto 24px auto

    button.btn-primary
        letter-spacing: 1px
</style>